<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                    <div class="col-auto">
                        <label class="col-form-label text-primary">Tipo:</label>
                    </div>
                    <div class="col-auto">
                        <select v-model="Filtro.TipoMenu" @change="Lista" class="form-control form-select">
                            <option value="">Todos</option>
                            <option value="Menu">Menu</option>
                            <option value="SubMenu">Sub Menu</option>
                            <option value="Apartado">Apartado</option>
                            <option value="SubApartado">Sub Apartado</option>
                        </select>
                    </div>
            </template>

            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Tipo de menú</th>
                <th :class="StyleTh">Menú asociado</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index" >
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.TipoMenu}}</p></td>               
                    <td><p :class="StyleTd">{{lista.MenuAsociado}}</p></td>
                    <td class="text-end">
                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdPanel" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <button type="button" @click="AsignarPermisos(lista);" class="btn btn-link text-secondary px-3 mb-0 mr-1">
                                    <i class="fas fa-key text-warning"></i> Asignar permiso
                                </button>
                            </template>
						</CBtnAccion>  
                    </td>  
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros> 
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
			<template slot="Form">
				<FormAsig :poBtnSave="oBtnSave2"></FormAsig>
			</template>
		</CModal>
    </div>
</template>

<script>

import moment from 'moment';
import Form       from '@/views/catalogos/paneles/Form.vue';
import FormAsig   from '@/views/catalogos/paneles/FormAsignacion.vue';
import Configs    from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPaneles';
const EmitAsigna  = 'seccionPermisosPanel';

export default {
    name: 'ListaPanelMenu',
    props: ['sFiltros','pOrigen'],
    components: {
        Form, FormAsig
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado Menús',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                TipoMenu:'',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle:  "Formulario menú",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:   'lg',
            },
            oBtnSave: {
                toast:       0,
                IsModal:     true,
                DisableBtn:  false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModal2:{
                ModalTitle:  "Asignación De Permisos",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitAsigna,
                ModalSize:   'lg',
            },
            oBtnSave2: {
                Toast:       0,
                IsModal:     true,
                ShowBtnSave: true,
                DisableBtn:  false,
                EmitSeccion: EmitAsigna,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("panelmenu",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    TipoMenu:this.Filtro.TipoMenu,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('panelmenu/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        AsignarPermisos(item) {
            this.bus.$emit('NewModal_'+EmitAsigna,item);
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('List_'+EmitAsigna);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('List_'+EmitAsigna,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
